export default __webpack_public_path__ + "static/media/link-to.08d37dfe.svg";